module.exports = __webpack_public_path__ + "img/1.450598e0.jpg";